import { computed, ref } from 'vue'
import { getRequisitionsAction } from '@/api/functions/requisitions/get-requisitions.action'
import type { RequisitionFilters } from '@/api/typings/requisition.typing'
import { useQueryApi } from './useApi'

export function useRequisitions(initialFilters: RequisitionFilters = {}) {
  const currentPage = ref(initialFilters.page || 1)
  const activeFilters = ref<RequisitionFilters>({ ...initialFilters })

  const query = useQueryApi({
    queryKey: computed(() => ['requisitions', { ...activeFilters.value, page: currentPage.value }]),
    queryFn: () =>
      getRequisitionsAction({
        ...activeFilters.value,
        page: currentPage.value,
      }),
    // keepPreviousData: true,

    staleTime: 1000 * 60 * 3,
  })

  const requisitions = computed(() => query.data.value?.data ?? [])
  const pagination = computed(() => query.data.value?.pagination)
  const message = computed(() => (query.data.value?.data?.length === 0 ? 'چیزی پیدا نشد' : ''))

  const nextPage = () => {
    if (pagination.value?.hasNextPage) currentPage.value++
  }

  const prevPage = () => {
    if (currentPage.value > 1) currentPage.value--
  }

  const goToPage = (page: number) => {
    currentPage.value = page
  }

  const updateFilters = (newFilters: RequisitionFilters) => {
    const cleanFilters = Object.fromEntries(
      Object.entries(newFilters).filter(
        ([key, value]) => key !== 'page' && value !== '' && value !== null && value !== undefined
      )
    )
    activeFilters.value = { ...initialFilters, ...cleanFilters }
    currentPage.value = 1
  }

  const refetchRequisitions = async () => {
    await query.refetch()
  }

  return {
    // state
    requisitions,
    pagination,
    message,
    currentPage,
    activeFilters,

    // methods
    nextPage,
    prevPage,
    goToPage,
    updateFilters,
    refetchRequisitions,

    // vue-query
    ...query,
  }
}
